<template>
  <div class="mission-check-in-point-section">
    <div class="mission-check-in-point-section__check">
      <mission-check-icon v-if="checkPoint.checked" />
    </div>
    <div class="mission-check-in-point-section__main">
      <p class="mission-check-in-point-section__name">{{ checkPoint.areaName[$i18n.locale] }}</p>
      <p class="mission-check-in-point-section__date">{{ checkPoint.eventCheckInMissionTerm }}</p>
    </div>
    <p class="mission-check-in-point-section__map" v-if="checkPoint.googleMapUrl">
      <a
        :href="checkPoint.googleMapUrl"
        class="mission-check-in-point-section__map-link"
        target="_blank"
      >
        <mission-check-point-map-icon />
      </a>
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import MissionCheckIcon from '@/components/MissionPage/MissionListPane/parts/icons/MissionCheckIcon.vue'
import MissionCheckPointMapIcon from '@/components/MissionPage/MissionListPane/parts/icons/MissionCheckPointMapIcon.vue'
import { CheckPointType } from '@/components/MissionPage/hook/useMissionProgressData'

export default defineComponent({
  name: 'MissionCheckInPointSection',
  components: {
    MissionCheckPointMapIcon,
    MissionCheckIcon,
  },
  props: {
    /**
     * イベントチェックイン場所情報
     */
    checkPoint: {
      type: Object as PropType<CheckPointType>,
      required: true,
    },
  },
  setup() {
    return {}
  },
})
</script>

<style scoped lang="scss">
.mission-check-in-point-section {
  display: flex;
  gap: 4px;
  align-items: center;
  width: 100%;
  padding: 6px 0;

  &__check {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
  }

  &__main {
    flex-grow: 1;

    @media screen and (min-width: $responsiveTabletWidth) {
      display: flex;
      gap: 4px;
      align-items: center;
    }
  }

  &__name {
    font-size: 12px;
    font-weight: 700;
    color: #73ffdd;
    letter-spacing: 0.02em;
    line-height: 1.25;
  }

  &__date {
    font-size: 12px;
    font-weight: 700;
    color: rgba(#73ffdd, 0.75);
    letter-spacing: 0.02em;
    line-height: 1.25;

    @media screen and (min-width: $responsiveTabletWidth) {
      margin-left: auto;
      white-space: nowrap;
    }
  }

  &__map {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
  }
}
</style>
